import { isDefined, isNotDefined } from '@sgme/fp';
import { useContext } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import {
  TargetAccumulatorContext,
  useTargetAccumulatorSelector,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { getTargetAccumulatorQuote, selectTargetAccumulatorEspSpot } from '@/store/targetAccumulator/selectors.ts';

export function SpotField() {
  const { tileId } = useContext(TargetAccumulatorContext);
  const espSpot = useAppSelector((state) => selectTargetAccumulatorEspSpot(state, tileId));

  const rfsSpot = useTargetAccumulatorSelector((targetAccumulator) => {
    const quote = getTargetAccumulatorQuote(targetAccumulator);
    if (isNotDefined(quote)) {
      return undefined;
    }
    return { bid: quote.spot.bid, ask: quote.spot.ask };
  });

  return (
    <div className="form-group form-group-sm d-flex my-1 no-gutters">
      <div className="pe-1 col-form-label col-form-label-sm col-4 text-nowrap text-end">
        <FormattedMessage id="targetAccumulator.fields.spot" />
      </div>
      <div className="d-flex flex-column px-1 col-7 justify-content-center fs-6" data-e2e="midPrice-spot">
        {isDefined(espSpot) && isNotDefined(rfsSpot) && <FormattedNumber value={espSpot} maximumFractionDigits={10} />}

        {isDefined(rfsSpot) && (
          <div data-e2e="rfs-spot" className="monospace-numbers">
            <FormattedNumber value={rfsSpot.bid} maximumFractionDigits={10} />
            <span> / </span>
            <FormattedNumber value={rfsSpot.ask} maximumFractionDigits={10} />
          </div>
        )}

        {isNotDefined(rfsSpot) && isNotDefined(espSpot) && <span className="text-secondary">-</span>}
      </div>
    </div>
  );
}
